import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 新增合作伙伴到客商编码
export function syncPartnerCode2FinanceCode(params) {
  return request({
    url: URL.finance.financeCodeMapping.syncPartnerCode2FinanceCode,
    method: 'get',
    params
  })
}

// 同步合作伙伴到客商编码
export function syncPartnerToFinanceCode(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.finance.financeCodeMapping.syncPartnerToFinanceCode,
    method: 'post',
    data
  })
}

// 开票抬头同步合作伙伴到客商编码
export function titleSyncPartnerToFinanceCode(requestBody) {
  return request({
    url: URL.finance.financeCodeMapping.titleSyncPartnerToFinanceCode,
    method: 'post',
    data: requestBody
  })
}

// 修改合作伙伴代码同步到客商编码
export function updateFinanceCodeByPartnerCode(params) {
  return request({
    url: URL.finance.financeCodeMapping.updateFinanceCodeByPartnerCode,
    method: 'get',
    params
  })
}

// 查询列表
export function query(requestBody) {
  return request({
    url: URL.finance.financeCodeMapping.query,
    method: 'post',
    data: requestBody
  })
}

// 获取详情
export function detail(requestBody) {
  return request({
    url: URL.finance.financeCodeMapping.detail,
    method: 'post',
    data: requestBody
  })
}

// 新增/修改保存
export function save(requestBody) {
  return request({
    url: URL.finance.financeCodeMapping.save,
    method: 'post',
    data: requestBody
  })
}

// 删除
export function remove(requestBody) {
  return request({
    url: URL.finance.financeCodeMapping.remove,
    method: 'post',
    data: requestBody
  })
}

// 获取金蝶ID
export function getKingdeId(data) {
  return request({
    url: URL.finance.financeCodeMapping.getKingdeId,
    method: 'post',
    data
  })
}

// 更新客商资料
export function updateCustomerInfo(data) {
  return request({
    url: URL.finance.financeCodeMapping.updateCustomerInfo,
    method: 'post',
    data
  })
}
